var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71703 1.23886C3.03275 0.554578 1.92331 0.554577 1.23904 1.23885C0.554761 1.92313 0.554761 3.03256 1.23904 3.71684L7.52206 9.99986L1.23904 16.2829C0.554762 16.9672 0.554761 18.0766 1.23904 18.7609C1.92332 19.4451 3.03275 19.4451 3.71702 18.7609L10 12.4778L16.2831 18.7609C16.9673 19.4451 18.0768 19.4451 18.761 18.7609C19.4453 18.0766 19.4453 16.9672 18.761 16.2829L12.478 9.99986L18.761 3.71684C19.4453 3.03257 19.4453 1.92313 18.7611 1.23886C18.0768 0.554578 16.9673 0.554578 16.2831 1.23886L10 7.52188L3.71703 1.23886Z",
    fill: "#719D8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMark);
export default __webpack_public_path__ + "static/media/cross_mark.6166b5f831487f9043fc94dd5b5480b7.svg";
export { ForwardRef as ReactComponent };